import * as Yup from 'yup';

export const ProfileSchema = Yup.object().shape({
  name: Yup.string()
    .max(25, 'Maximum 25 characters')
    .required('Name is required'),
});
